import { render, staticRenderFns } from "./DocCount.vue?vue&type=template&id=4b1aae28&"
import script from "./DocCount.vue?vue&type=script&lang=js&"
export * from "./DocCount.vue?vue&type=script&lang=js&"
import style0 from "./DocCount.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports